import ModalAdmin from 'components/molecules/admin/ModalAdmin'
import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import CustomButton from 'components/atoms/CustomButton'
import { useTranslation } from 'react-i18next'
import { Card, Radio, Space } from 'antd'
import { Delete } from 'assets/images'
import { useMutation } from 'react-query'
import { addPaymentCard, deleteCard, onAddCardpaymentConfirm, setDefaultCard } from 'api'
import { showErrorMessage, showSuccessMessage } from 'utils/showMessage'
import { useSelector } from 'react-redux'
import ErrorIcon from '@mui/icons-material/Error'
import { isExpired } from 'lib/utils'
import { Elements } from '@stripe/react-stripe-js'
import CheckoutForm from '../../auth/CheckoutForm'
import { loadStripe } from '@stripe/stripe-js'
import { renderCardIcon } from '../../../../utils/cardIcons'

const ChangePaymentCardModal = ({ show, onClose, onSubmit, cards, companyId }) => {
  const { t } = useTranslation();

  const is_default = cards?.find(el => el?.is_default)
  const token = useSelector((state) => state.admin.access_token)


  const [defaultCard, setAsDefaultCard] = useState(is_default?.id);
  const [isLoading, setIsLoading] = useState(false)
  const [isAddCard, setIsAddCard] = useState(false)


  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  console.log("stripePromise")
  console.log(stripePromise)
  const [clientSecret, setClientSecret] = useState(null)
  const [setupIntentId, setSetupIntentId] = useState(null)


  function closeModal() {

    onClose()

  }


  const addCard = useMutation({
    mutationKey: 'payment-cards',

    mutationFn: (values) => addPaymentCard(values, token, companyId),
    onSuccess: async (res) => {

      setClientSecret(res?.resData?.data?.client_secret);
      setSetupIntentId(res?.resData?.data?.setup_intent_id);

    },
    onError: (err) => {

      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const confirm = useMutation({
    mutationKey: 'payment-card/confirm',
    mutationFn: (values) => onAddCardpaymentConfirm(values, token, localStorage.getItem('companyId')),
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: async (res) => {
      setIsAddCard(false)
      onSubmit()
      closeModal()

    },
    onError: (err) => {

      setIsLoading(false)
      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const setDefault = useMutation({
    mutationKey: 'set-default',
    mutationFn: (cardId) => setDefaultCard(token, companyId, cardId),
    onSuccess: async (res) => {
      showSuccessMessage('Carta impostata come pagamento di default')
      onSubmit()


    },
    onError: (err) => {

      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const onDeleteCard = useMutation({
    mutationKey: 'delete-card',
    mutationFn: (cardId) => deleteCard(token, companyId, cardId),
    onSuccess: async (res) => {
      // console.log('res', res);
      onSubmit()


    },
    onError: (err) => {

      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const onChange = (e) => {
   // console.log('e.target.value', e.target.value);
    setAsDefaultCard(e.target.value);
   

  };



  useEffect(() => {

    if (is_default?.id) {
      setAsDefaultCard(is_default?.id)
    }

  }, [is_default])

  useEffect(()=>{
    if(isAddCard){
      addCard.mutate()
    }

  },[isAddCard])


  return (
    <ModalAdmin
      width={448}
      show={show}
      onClose={closeModal}
      title={
        <div className="flex flex-col">

          {cards?.length > 0 ? <span>{t('Pay.UpdatePaymentMethod')}</span> : <span>{t('Pay.AddPaymentMethod')}</span>}



        </div>
      }>
      <Box
        noValidate
        component="form"
        className={`flex flex-col min-h-[466px]`}
      >

        {isAddCard && (
          <>
            <Elements stripe={stripePromise}>
              <CheckoutForm
                isLoading={isLoading}
                clientSecret={clientSecret}
                isDirect={false}
                isAdmin={true}
                closeAddCard={() => {
                  setIsAddCard(false)
                }}
                onSubmit={() => {

                  const body = {
                    setup_intent_id: setupIntentId, //  lo stesso della prepare

                  }

                  confirm.mutate(body)

                }} />
            </Elements>


          </>
        )}


        {!isAddCard && (<>

          {cards?.length > 0 && (
            <>
              <Radio.Group onChange={onChange} value={defaultCard} className="admin-plan-radio">

                <Space direction="vertical" className='w-full'>

                  {cards?.map((el, index) => (
                    <Card
                      key={index}
                      className={`rounded-lg transition-colors cursor-pointer ${defaultCard === el?.id ? 'bg-[#3F3F3F] border-none' : 'bg-[#282828]  border-none'
                        }`}
                      hoverable>
                      <Radio value={el?.id} className='w-full'>
                        <div style={{ width: '325px' }} className='flex items-center justify-between'>
                          <div className='flex items-center'>
                            {renderCardIcon(el?.card_type)}
                            <div className='ml-3'>
                              <p className='text-white text-sm font-semibold'>{el?.card_type}</p>
                              <p className='text-[rgba(255, 255, 255, 0.48)] text-xs font-normal'>****{el?.last_four_digit}</p>

                              {isExpired(el?.expired_at).expired && (
                                <div className='flex items-center'>

                                  <ErrorIcon style={{
                                    width: '15px',
                                    color: '#E53E3E'
                                  }} />

                                  <p className='text-xs font-normal text-[#E53E3E] ml-1'> {t('Pay.ExpiredAt')} {isExpired(el?.expired_at).formattedDate}</p>
                                </div>

                              )}

                            </div>
                          </div>

                          {!el?.is_default && (
                            <img onClick={() => {
                              onDeleteCard.mutate(el?.id)
                            }} src={Delete} alt="" />
                          )}

                        </div>


                      </Radio>
                    </Card>
                  ))}




                </Space>



              </Radio.Group>
              <p className='mt-4 mb-4'>{t('Or')}</p>
            </>

          )}



          <CustomButton className='max-w-max' buttonColor="secondary" onClick={() => {
            setIsAddCard(true)
          }}>
            <div className='flex'>
              <p className='mr-2'>+</p>
              {t('Pay.AddPaymentMethod')}
            </div>

          </CustomButton>


          {cards?.length > 0 && (
            <div
              className={`flex gap-2 pt-10 justify-end`}
            >


              <CustomButton
                style={{ flex: '1' }} buttonColor="secondary" onClick={closeModal}>
                {t('Cancel')}
              </CustomButton>
              <CustomButton
                style={{ flex: '1' }}
                onClick={() => {
                
                  setDefault.mutate(defaultCard)
                }}
              >
                {t('Update')}
              </CustomButton>
            </div>
          )}

        </>)}



      </Box>
    </ModalAdmin>
  )
}

export default ChangePaymentCardModal
